export interface IRemoveFundSourceResponse {
    /**
     * Description
     */
    readonly description?: string;
    /**
     * Success
     */
    readonly success: boolean;
}
